module.exports = __webpack_public_path__ + "static/img/zhongqiu.4ae9224.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/zhongqiu.jpg
// module id = vMN+
// module chunks = 0